import { DropsTabStatus } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { maxDaresReachedMessage } from 'root/src/shared/constants/dropEvent';
import { PointsApplicationState } from 'root/src/server/modules/points/types/types';
// Drives the status badge on hero/cards. The list view has no per-drop status, so we derive
// it from the active tab (Live / Coming soon / Private).
export const DROP_TAB_STATUS = {
    [DropsTabStatus.Live]: { label: 'Live Now', badge: 'border border-solid border-neon-green/40 bg-black/60 text-neon-green', dot: 'bg-neon-green' },
    [DropsTabStatus.Soon]: { label: 'Coming Soon', badge: 'border border-solid border-neon-amber/40 bg-black/60 text-neon-amber', dot: 'bg-neon-amber' },
    [DropsTabStatus.Private]: { label: 'Private', badge: 'border border-solid border-neon-purple/40 bg-black/60 text-neon-purple', dot: 'bg-neon-purple' },
};
// Mirrors the legacy DropUserInfoWidget: derives the participation CTA from dropUserInfo.
export const getDropCta = (drop) => {
    const info = drop.dropUserInfo;
    if (!info) {
        return { label: 'Check Out Dares', kind: 'action' };
    }
    if (info.maxDares <= 0) {
        return { label: 'Need more Viewers to Participate', kind: 'locked' };
    }
    if (info.countOfAcceptedDares >= info.maxDares) {
        return { label: maxDaresReachedMessage, kind: 'maxed' };
    }
    return { label: 'Check Out Dares', kind: 'action' };
};
// Mirrors the legacy useDropPointsIcon: the points chip colour + tooltip reflect the
// creator's points application state. Hidden when rejected (unless allowlisted).
// `isPointsEligible` (usePointsEligibility: partner + CCV, allowlist, admin) hides the chip from
// creators who cannot earn points at all; anyone with an application on record keeps their status.
export const getPointsIndicator = (drop, isPointsEligible) => {
    const info = drop.dropUserInfo;
    const state = info === null || info === void 0 ? void 0 : info.pointsApplicationState;
    const canSeePoints = isPointsEligible || Boolean(state) || Boolean(info === null || info === void 0 ? void 0 : info.isPointsReservationComplete);
    const show = drop.awardPoints && canSeePoints && (state !== PointsApplicationState.REJECTED || Boolean(drop.isCreatorPointsAllowlisted));
    if (info === null || info === void 0 ? void 0 : info.isPointsReservationComplete) {
        return { show, className: 'border border-solid border-primary/40 bg-black/60 text-primary', message: 'Your points reservation was completed!' };
    }
    switch (state) {
        case PointsApplicationState.APPROVED:
            return { show, className: 'border border-solid border-neon-green/40 bg-black/60 text-neon-green', message: 'Your points application was approved' };
        case PointsApplicationState.REJECTED:
            return { show, className: 'border border-solid border-destructive/40 bg-black/60 text-destructive', message: 'Your points application was rejected' };
        case PointsApplicationState.ON_HOLD:
            return { show, className: 'border border-solid border-neon-amber/40 bg-black/60 text-neon-amber', message: 'Your points application is temporarily on hold' };
        case PointsApplicationState.PENDING:
            return { show, className: 'border border-solid border-neon-amber/40 bg-black/60 text-neon-amber', message: 'Your points application is in review' };
        default:
            return { show, className: 'border border-solid border-neon-cyan/40 bg-black/60 text-neon-cyan', message: 'Drop awards points' };
    }
};
